import { useTranslation } from "react-i18next";
import ContainerLayout from "../../../components/container-layout/ContainerLayout";
import StateComponents from "../../../components/state-component/StateComponents";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import StepperCustom from "../../../components/step/Stepper";
import { useEffect, useRef, useState } from "react";
import { Box, Divider, Grid, IconButton, InputBase, MenuItem, Typography, useMediaQuery, useTheme } from "@mui/material";
import { ButtonContained, ButtonOutlined } from "../../../components/button/ButtonCustoms";
import ContainerButton from "../../../components/button/ContainerButton";
import { EvidencePayment, FileApplicant, FormApplicant, TermPayment } from "../list-applicants/applicent-detail";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import FilterSelect from "../../../components/select/filterSelect";
import { ReactComponent as Bag } from '../../../assets/icons/bag-button.svg'
import { ReactComponent as Document } from '../../../assets/icons/document.svg'
import UploadFile from "../../../components/upload/UploadFile";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { AdmissionFrontApi } from "../../../api/admission-front/admission-front.api";
import { dateToView, timeToView } from "../../../utils/date.utils";
import { InterviewStudentApi } from "../../../api/interview-student/interview-student.api";
import { alertError, alertSuccess, swalError } from "../../../components/alert/swal";
import { handleTypingNumber } from "../../../utils/app.utils";
import CancelIcon from '@mui/icons-material/Cancel';

import moment from "moment";
import { ADMISSION_STATUS, renderStatus, renderStatusEn } from "./enum/admission.enum";
import StatusCustom from "../../../components/status/statusCustom";
export default function AdmissionDetail() {
    const { t } = useTranslation();
    const { id } = useParams()
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();

    const [form, setForm] = useState<any>();
    const [formInterview, setFormInterview] = useState<any>();
    const [tabStep, setTebStep] = useState(0);
    const allStep = [
        {
            name: "Personal Information",
            isAccept: false,
            icon: null
        },
        {
            name: "Proof of Application Payment",
            isAccept: false,
            icon: null
        },
        {
            name: "Entrance Exam Information",
            isAccept: false,
            icon: null
        },
        {
            name: "Interview Information",
            isAccept: false,
            icon: null
        },

        {
            name: "Tuition Payment",
            isAccept: false,
            icon: null
        },
        {
            name: "Your Student Email",
            isAccept: false,
            icon: null
        },
    ];

    const getDetail = async () => {
        dispatch(setLoading());

        await AdmissionFrontApi.findOne(id).then((res) => {
            if (res.status < 300) {
                setForm(res.data.data)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const getDetailInterview = async () => {

        await InterviewStudentApi.getInterviewStudentById(id).then((res) => {
            if (res.status < 300) {
                setFormInterview(res.data.data)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
        })
    }
    useEffect(() => {
        getDetail()
        getDetailInterview()
    }, [])

    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("Application Information")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("IBSC Online Admission"),
                                disabled_match: true,
                                pathName: routeName.admission.HistoryOnlineAdmission
                            },

                            {
                                key: "complaintSubmit",
                                name: t("Application Information"),
                                pathName: routeName.admission.AdmissionDetail
                            },
                        ]}
                    />
                }

                content={
                    <>
                        {[ADMISSION_STATUS.FAILED_THE_EXAM,ADMISSION_STATUS.REJECTED, ADMISSION_STATUS.INTERVIEW_FAILED, ADMISSION_STATUS.TUITION_PAYMENT_REVIEW].includes(form?.admission_status) && <><Box sx={{ maxWidth: '300px', marginBottom: "10px" }}>
                            <StatusCustom
                                disableMaxWidth
                                text={renderStatusEn(form?.admission_status)}
                                type={renderStatusEn(form?.admission_status)}
                            />
                        </Box>
                        <Typography>Remark: {form?.admission_status_remark || formInterview?.interview_student_result_remark || '-'}</Typography></>}
                        <div className='w-full'>
                            <section
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "24px",
                                }}
                            >
                                <StepperCustom
                                    step={tabStep}
                                    setStep={setTebStep}
                                    stepLabel={allStep}
                                    view={true}
                                />
                            </section>
                            {tabStep === 0 &&
                                <div style={{ display: 'flex', flexDirection: 'column', gap: "20px" }}>
                                    <FormApplicant form={form} />
                                    <FileApplicant form={form} />

                                </div>
                            }
                            {tabStep === 1 &&
                                <>
                                    <EvidencePayment form={form} />
                                </>
                            }
                            {tabStep === 2 &&

                                <>
                                    {form?.examination?.id_period_examination_student ? <>
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                                            <Box sx={{
                                                boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                                padding: "20px",
                                                borderRadius: "20px",
                                                display: "flex",
                                                flexDirection: 'column',
                                                gap: '10px'
                                            }}>
                                                <Grid container spacing={2} columns={18}
                                                // sx={{
                                                //     display: 'flex', alignItems: 'center', gap: "10px"
                                                // }}
                                                >
                                                    <Grid item xs={18} md={3}>
                                                        <Typography sx={{ color: "#828282" }}>Exam Session Name</Typography>
                                                        <Typography>{form?.examination?.period_examination_name || '-'}</Typography>
                                                    </Grid>
                                                    <Grid item xs={18} md={2}>
                                                        <Typography sx={{ color: "#828282" }}>Exam Date</Typography>
                                                        <Typography>{form?.examination?.period_examination_start_date ? dateToView(form?.examination?.period_examination_start_date) : '-'}</Typography>
                                                    </Grid>
                                                    <Grid item xs={18} md={2}>
                                                        <Typography sx={{ color: "#828282" }}>Exam Time</Typography>
                                                        <Typography>{`${form?.examination?.period_examination_start_time} - ${form?.examination?.period_examination_end_time}`}</Typography>
                                                    </Grid>
                                                    <Grid item xs={18} md={2}>
                                                        <Typography sx={{ color: "#828282" }}>Exam Format</Typography>
                                                        <Typography>{form?.examination?.examination_types}</Typography>
                                                    </Grid>
                                                    <Grid item xs={18} md={3}>
                                                        <Typography sx={{ color: "#828282" }}>Number of Questions</Typography>
                                                        <Typography sx={{ textAlign: 'center' }}>{form?.examination?.examination_detail_count}</Typography>
                                                    </Grid>
                                                    <Grid item xs={18} md={1}>
                                                        <Typography sx={{ color: "#828282" }}>Score</Typography>
                                                        <Typography sx={{ textAlign: 'center' }}>{form?.examination?.examination_max_score}</Typography>
                                                    </Grid>
                                                    <Grid item xs={18} md={2}>
                                                        <Typography sx={{ color: "#828282" }}>Passing Score</Typography>
                                                        <Typography sx={{ textAlign: 'center' }}>{form?.examination?.period_examination_pass}</Typography>
                                                    </Grid>
                                                    <Grid item xs={18} md={3}>
                                                        <ContainerButton
                                                            sxContainer={{ my: 3 }}
                                                            buttonData={[
                                                                {
                                                                    seq: 1,
                                                                    buttonProps: {
                                                                        onClick: () => { navigate(routeName.admission.FormExamination.replace(':id', `${id}`).replace(':id_period_examination_student', form?.examination?.id_period_examination_student)) },
                                                                        disabled: form?.examination?.period_examination_status !== "OPEN"
                                                                    },
                                                                    key: "APPROVE",
                                                                    label: "Take Exam",
                                                                    type: "APPROVE"
                                                                },

                                                            ]}
                                                        />
                                                    </Grid>

                                                </Grid>
                                            </Box>
                                        </Box>
                                    </> : <Box sx={{ margin: '20px auto', width: "100%" }}><Typography sx={{ color: '#828282' }}>Please wait for verification from the staff...</Typography></Box>}
                                </>

                            }
                            {tabStep === 3 &&
                                // <EducationalRecord />
                                <>{formInterview ?
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                                        <Box sx={{
                                            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                            padding: "20px",
                                            borderRadius: "20px",
                                            display: "flex",
                                            flexDirection: 'column',
                                            gap: '10px'
                                        }}>
                                            <Grid container spacing={2}
                                            // sx={{
                                            //     display: 'flex', alignItems: 'center', gap: "10px"
                                            // }}
                                            >
                                                <Grid item xs={18} md={2.5}>
                                                    <Typography sx={{ color: "#828282" }}>Interview appointment date</Typography>
                                                    <Typography>{formInterview?.interview_student_date ? dateToView(formInterview?.interview_student_date) : '-'}</Typography>
                                                </Grid>
                                                <Grid item xs={18} md={2.5}>
                                                    <Typography sx={{ color: "#828282" }}>Interview appointment time</Typography>
                                                    <Typography>{formInterview?.interview_student_date ? timeToView(formInterview?.interview_student_date) : '-'}</Typography>
                                                </Grid>
                                                <Grid item xs={18} md={5}>
                                                    <Typography sx={{ color: "#828282" }}>link</Typography>
                                                    <Typography onClick={() => window.open(formInterview?.interview_student_link, '_blank')} sx={{ textDecoration: 'underline', cursor: 'pointer' }}>{formInterview?.interview_student_link}</Typography>
                                                </Grid>

                                                <Grid item xs={18} md={2}>
                                                    <ContainerButton
                                                        sxContainer={{ my: 3 }}
                                                        buttonData={[
                                                            {
                                                                seq: 1,
                                                                buttonProps: {
                                                                    onClick: () => {
                                                                        navigator.clipboard.writeText(formInterview?.interview_student_link);

                                                                    },
                                                                },
                                                                key: "APPROVE",
                                                                label: "Copy link",
                                                                type: "APPROVE"
                                                            },

                                                        ]}
                                                    />
                                                </Grid>

                                            </Grid>
                                        </Box>
                                    </Box> : <Box sx={{ margin: '20px auto', width: "100%" }}><Typography sx={{ color: '#828282' }}>Please wait for verification from the staff...</Typography></Box>}
                                </>
                            }
                            {tabStep === 4 &&
                                <>
                                    {[ADMISSION_STATUS.WAITING_FOR_TUITION_PAYMENT, ADMISSION_STATUS.TUITION_PAYMENT_REVIEW].includes(form?.admission_status) ? <AdmissionStudentTermPayment form={form} setForm={setForm} /> :
                                        <>{form?.admission_student_term_payment ? <TermPayment form={form} /> : <Box sx={{ margin: '20px auto', width: "100%" }}><Typography sx={{ color: '#828282' }}>Please wait for verification from the staff...</Typography></Box>}</>}
                                </>
                            }
                            {tabStep === 5 &&
                                <>{form?.student ? <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                                    <Box sx={{
                                        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                        padding: "20px",
                                        borderRadius: "20px",
                                        display: "flex",
                                        flexDirection: 'column',
                                        gap: '10px'
                                    }}>
                                        <Grid container spacing={2}
                                        // sx={{
                                        //     display: 'flex', alignItems: 'center', gap: "10px"
                                        // }}
                                        >
                                            <Grid item xs={18} md={2.5}>
                                                <Typography sx={{ color: "#828282" }}>Student ID</Typography>
                                                <Typography>{form?.student?.student_no || '-'}</Typography>
                                            </Grid>
                                            <Grid item xs={18} md={2.5}>
                                                <Typography sx={{ color: "#828282" }}>Your student email</Typography>
                                                <Typography>{form?.student?.student_email || '-'}</Typography>
                                            </Grid>
                                            <Grid item xs={18} md={5}>
                                                <Typography sx={{ color: "#828282" }}>Password</Typography>
                                                {/* <Typography >{form?.student?.student_no || '' }</Typography> */}
                                                <InputBase value={form?.student?.student_no?.length > 8 ? form?.student?.student_no.slice(-8) : form?.student?.student_no } fullWidth sx={{ '&::after': { content: 'none' }, '&::before': { content: 'none' } }} type='password' name="" id="" />
                                            </Grid>

                                            <Grid item xs={18} md={2}>
                                                <ContainerButton
                                                    sxContainer={{ my: 3 }}
                                                    buttonData={[
                                                        {
                                                            seq: 1,
                                                            buttonProps: {
                                                                onClick: () => {
                                                                    navigator.clipboard.writeText(form?.student?.student_no?.length > 8 ? form?.student?.student_no.slice(-8) : form?.student?.student_no);
                                                                },
                                                            },
                                                            key: "APPROVE",
                                                            label: "Copy",
                                                            type: "APPROVE"
                                                        },

                                                    ]}
                                                />
                                            </Grid>

                                        </Grid>
                                    </Box>
                                </Box> : <Box sx={{ margin: '20px auto', width: "100%" }}><Typography sx={{ color: '#828282' }}>Please wait for verification from the staff...</Typography></Box>}</>
                            }

                            <ContainerButton
                                sxContainer={{ my: 3 }}
                                buttonData={[
                                    {
                                        seq: 1,
                                        buttonProps: {
                                            onClick: () => {
                                                navigate(routeName.admission.HistoryOnlineAdmission)
                                            },
                                        },
                                        hidden: (tabStep === 4 && form?.admission_status === ADMISSION_STATUS.WAITING_FOR_TUITION_PAYMENT),
                                        key: "CANCEL",
                                        label: "Go back",
                                        type: "CANCEL"
                                    },
                                    // {
                                    //     seq: 2,
                                    //     hidden: tabStep !== 4,
                                    //     buttonProps: {
                                    //         onClick: () => { },
                                    //     },
                                    //     key: "SAVE",
                                    //     label: "บันทึก",
                                    //     type: "SAVE"
                                    // },


                                ]}
                            />
                        </div>
                    </>
                }
            />

        </div>
    )
}

const AdmissionStudentTermPayment = (props: any) => {
    const { form, setForm } = props
    const url = "/MAN_UW-MCU58-Admissions_2.pdf";

    const fileRef = useRef<any>()
    const { id } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [type, setType] = useState<string>('THB')
    const [formPayment, setFormPayment] = useState<any>({
        payment_type: "ATTACH_SLIP"
    });
    const [pathUrl, setPathUrl] = useState<string>("");
    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
        };
        init();
    }, []);
    const onImageChange = async (event: any) => {
        if (event.target.files && event.target.files[0]) {
            const formData = new FormData();

            //DRAFT
            formData.append('file', event.target.files[0]);
            formData.append('id_admission_student', `${id}`);
            formData.append('payment_catalog', 'TERM');

            await AdmissionFrontApi.register_payment_file(formData).then((res: any) => {
                if (res.status < 300) {
                    // setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, id_admission_student_register_payment: res.data.data?.id_admission_student_register_payment, payment_file: res.data.data } })
                    setFormPayment({ ...formPayment, id_admission_student_register_payment: res.data.data?.id_admission_student_register_payment, payment_file: res.data.data })
                    // swalSuccess('ยืนยันการชำระเงิน', 'ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ')
                    if (fileRef.current) {
                        fileRef.current.value = null;
                    }
                }
            }).catch((error: any) => {
                console.log(error)
                if (fileRef.current) {
                    fileRef.current.value = null;
                }
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        }
    }
    const handleSubmit = async () => {
        const body = {
            ...formPayment,
            payment_date: `${formPayment?.payment_date}T${formPayment?.payment_date_time}`,
            payment_file: undefined
        }
        dispatch(setLoading());
        if (id) {
            await AdmissionFrontApi.patch_term_payment(Number(id), body)
                .then((res) => {
                    if (res.status < 300) {
                        alertSuccess("บันทึก", "บันทึก เรียบร้อย");
                        navigate(routeName.admission.HistoryOnlineAdmission)
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError("บันทึก", "บันทึก ไม่สำเร็จ");
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        }
    }
    return (
        <>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                <Grid container spacing={2}>

                    <Grid item xs={12}>
                        <Box sx={{
                            // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                            // padding: "40px",
                            // borderRadius: "20px",
                            display: "flex",
                            flexDirection: 'column',
                            gap: '10px'
                        }}>
                            <Typography sx={{ fontWeight: "600" }}>Student ID: {form?.student?.student_no}</Typography>
                            <Typography sx={{ fontWeight: "600" }}>Payment link: <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => window.open(form?.url_payment_term, '_blank')}>{form?.url_payment_term}</span></Typography>
                            <Typography sx={{ fontWeight: "600", fontSize: '24px' }}>Payment Guide</Typography>

                        </Box>
                    </Grid>
                    <Grid item xs={12} md={7}>
                        {/* <Box sx={{
                            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                            padding: "40px",
                            borderRadius: "20px",
                            display: "flex",
                            flexDirection: 'column',
                            gap: '10px'
                        }}>
                            <Box sx={{
                                border: '2px solid #4A4A4A',
                                borderRadius: '18px', overflow: 'hidden',
                            }}>
                                <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                                    <Typography sx={{ fontWeight: "600", color: '#fff' }}>please mack a payment through bank transfer as below:</Typography>

                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '60px 20px' }}>
                                            <Box sx={{ display: 'flex', gap: '10px' }}>
                                                <Typography sx={{ color: "#737373" }}>ชื่อบัญชี </Typography>
                                                <Typography sx={{ color: "#000" }}>{form?.faculty?.payment_channels_term?.account_name_th}</Typography>

                                            </Box>
                                            <Box sx={{ display: 'flex', gap: '10px' }}>
                                                <Typography sx={{ color: "#737373" }}>Account Name </Typography>
                                                <Typography sx={{ color: "#000" }}>{form?.faculty?.payment_channels_term?.account_name_eng}</Typography>

                                            </Box>
                                            <Box sx={{ display: 'flex', gap: '10px' }}>
                                                <Typography sx={{ color: "#737373" }}>เลขที่บัญชี </Typography>
                                                <Typography sx={{ color: "#000" }}>{form?.faculty?.payment_channels_term?.account_no}</Typography>
                                            </Box>
                                            <Typography sx={{ color: "#737373" }}>Account No.</Typography>

                                            <Box sx={{ display: 'flex', gap: '10px' }}>
                                                <Typography sx={{ color: "#737373" }}>Account Type </Typography>
                                                <Typography sx={{ color: "#000" }}>{form?.faculty?.payment_channels_term?.account_type}</Typography>

                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ background: '#4A4A4A', padding: '10px', display: 'flex', alignItems: 'center', gap: "10px", borderRadius: '18px' }}>
                                <Typography sx={{ color: '#fff' }}>Currency</Typography>
                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    typeProps={[

                                        {
                                            seq: 1,
                                            type: "SELECT",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                labelId: "ss",
                                                // heading: "สกุลเงิน",
                                                onChange: (e) => {
                                                    setType(e.target.value)
                                                    // handleChange('form_type', index, e.target.value);
                                                },
                                                options: [
                                                    {
                                                        label: "THB",
                                                        value: 'THB',
                                                    },
                                                    {
                                                        label: "USD",
                                                        value: 'USD',
                                                    },
                                                ],
                                                selectId: "",
                                                value: type || ''
                                            }
                                        },


                                    ]} />
                                <Typography sx={{ color: '#fff' }}>Bachelor of arts degree : Application fee {type === 'THB' ? `${form?.course_tuition_fees?.price_bath} Thai Baht (THB)` : `${form?.course_tuition_fees?.price_usd} United States dollar (USD)`}</Typography>
                            </Box>
                        </Box> */}
                        <div style={{ width: "100%", height: "70vh", marginTop: "" }}>
                            <iframe
                                src={`/pdfjs-dist/web/viewer.html?file=${url}`}
                                width="100%"
                                height="100%"
                                frameBorder="0"
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box sx={{
                            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                            padding: "10px",
                            borderRadius: "20px",
                            height: "500px",
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: "center",
                            justifyContent: "center",
                            position: 'relative'
                        }} >
                            {formPayment?.payment_file ?
                                <img src={pathUrl + '/' + formPayment?.payment_file?.file_path + formPayment?.payment_file?.file_name} style={{ width: '100%', maxHeight: '450px', objectFit: 'contain' }} /> :
                                <>
                                    <ButtonContained buttonName='Choose Image' onClick={() => fileRef.current.click()} />
                                </>
                            }
                            <input ref={fileRef} className='hidden' type='file'
                                accept={"image/*"}
                                onChange={(e: any) => onImageChange(e)} />
                            {form?.admission_student_register_payment?.payment_file &&
                                <IconButton sx={{ position: "absolute", top: '20px', right: '20px' }} onClick={() => {
                                    // setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, id_admission_student_register_payment: '', payment_file: undefined } })
                                    setFormPayment({ ...formPayment, id_admission_student_register_payment: '', payment_file: undefined })

                                }}><CancelIcon sx={{ color: "#e7e7e7" }} /></IconButton>}
                        </Box>
                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => {
                                            navigate(-1)

                                        },
                                    },
                                    key: "CANCEL",
                                    label: "Cancel",
                                    type: "CANCEL"
                                },
                                {
                                    seq: 2,
                                    // hidden: tabStep !== 4,
                                    buttonProps: {
                                        onClick: () => {
                                            handleSubmit()
                                        },
                                    },
                                    key: "SAVE",
                                    label: "Confirm",
                                    type: "SAVE"
                                },


                            ]}
                        />
                    </Grid>
                </Grid>


                {/* <StateComponents
                    otherProps={{ spacing: 2 }}
                    typeProps={[
                        {
                            seq: 1,
                            type: "DATE",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                onChange: (e) => {
                                    setFormPayment({ ...formPayment, payment_date: moment(e).format('YYYY-MM-DD') })
                                    // setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, payment_date: moment(e).format('YYYY-MM-DD') } })
                                },
                                heading: 'Payment Date',
                                placeholder: 'Payment Date',
                                allowClear: true,
                                onClear: () => {
                                    // setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, payment_date: '' } })
                                    setFormPayment({ ...formPayment, payment_date: '' })
                                },
                                value: formPayment?.payment_date
                            },
                        },
                        {
                            seq: 2,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Payment Time",
                                onChange: (e) => {
                                    // setFormPayment({ ...formPayment, payment_date: moment(e).format('YYYY-MM-DD') })
                                    setFormPayment({ ...formPayment, payment_date_time: e.target.value })

                                },
                                value: formPayment?.payment_date_time || '',
                                type: 'time'
                            }
                        },
                        {
                            seq: 3,
                            type: "SELECT",
                            gridProps: {
                                xs: 12,
                                md: 1.5
                            },
                            fieldProps: {
                                labelId: "ss",
                                heading: "Currency",
                                onChange: (e) => {
                                    setFormPayment({ ...formPayment, payment_currency: e.target.value })
                                },
                                options: [
                                    {
                                        label: "THB",
                                        value: 'THB',
                                    },
                                    {
                                        label: "USD",
                                        value: 'USD',
                                    },

                                ],
                                selectId: "",
                                value: formPayment?.payment_currency,
                            }
                        },
                        {
                            seq: 4,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 3
                            },
                            fieldProps: {
                                heading: "Amount",
                                onChange: (e) => {
                                    setFormPayment({ ...formPayment, payment_amount: e.target.value })
                                },
                                value: formPayment?.payment_amount,
                                onkeypress: handleTypingNumber
                            }
                        },
                        {
                            seq: 5,
                            type: "TEXT_FIELD",
                            gridProps: {
                                xs: 12,
                                md: 1.5
                            },
                            fieldProps: {
                                heading: "Type",
                                onChange: (e) => {
                                    setFormPayment({ ...formPayment, payment_type: e.target.value })
                                },
                                disabled: true,
                                value: formPayment?.payment_type,
                            }
                        },
                    ]} /> */}
            </Box>

        </>
    )
}

